import React from 'react';
import { SVGProps } from './types';

const BankIcon = (props: SVGProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width={24}
      height={24}
      fill="none"
      {...props}
    >
      <path
        d="M11.9961 7.0127H12.0051"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M4 10.0078V18.5028M8 10.0078V18.5028"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M16 10.0078V18.5028M20 10.0078V18.5028"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M22 18.5029H2V22.0009H21.9997L22 18.5029Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M2.00551 7.01199L11.9844 2.00009C11.9872 1.99867 11.9906 1.99867 11.9934 2.00008L21.9945 7.01199C21.9979 7.01369 22 7.01715 22 7.02093V10.0078H2V7.02092C2 7.01714 2.00213 7.01369 2.00551 7.01199Z"
        stroke="currentColor"
        strokeWidth="1.5"
      />
    </svg>
  );
};

export { BankIcon };
